// HTTP client wrapper for API calls
export class ApiClient {
    constructor(baseUrl = '/api') {
        this.baseUrl = baseUrl;
    }
    // Validation endpoints
    async validateSRT(request) {
        return this.post('/validate/srt', request);
    }
    async validateText(request) {
        return this.post('/validate/text', request);
    }
    async validateAvidDS(request) {
        return this.post('/validate/avidds', request);
    }
    // Conversion endpoint
    async convert(request) {
        return this.post('/convert', request);
    }
    // Batch conversion endpoint
    async batchConvert(request) {
        return this.post('/convert/batch', request);
    }
    // Processing endpoints
    async balance(request) {
        return this.post('/process/balance', request);
    }
    async spacing(request) {
        return this.post('/process/spacing', request);
    }
    // Generic POST method
    async post(endpoint, data) {
        const url = `${this.baseUrl}${endpoint}`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        }
        catch (error) {
            console.error(`API call failed: ${endpoint}`, error);
            throw error;
        }
    }
}
// Singleton instance
export const apiClient = new ApiClient();
